export default "__VITE_ASSET__D12_tPwT__"